import { Button as ButtonAntD } from 'antd';
import styled from 'styled-components';

import { COLORS } from '../../../utils/theme/colors';

export const Button = styled(ButtonAntD)`
  height: 50px;
  padding-left: 32px;
  padding-right: 32px;
  border-radius: 3px;

  &.ant-btn-primary {
    background-color: ${({ theme }) => theme.primary};
    border-color: ${({ theme }) => theme.primary};
  }

  &.ant-btn:not(.ant-btn-primary):not(.ant-btn-dangerous) {
    &:hover {
      border-color: ${({ theme }) => theme.primary};
      color: ${({ theme }) => theme.primary};
    }
  }
`;

export const MessageBox = styled.div`
  color: red;
  font-size: 12px;
  margin-top: 4px;
`;

export const Label = styled.div`
  color: #7f7f7f;
  margin-bottom: 2px;
  font-weight: 300;
  font-size: 15px;
`;

export const RadioOption = styled.span`
  font-weight: 300;
  font-size: 16px;
`;

export const BadgeContainer = styled.div`
  display: flex;
  width: 30px;
  height: 30px;
  margin-right: 8px;
  align-items: center;
  justify-content: center;
  background-color: #515151;
  color: #fff;
  border-radius: 50%;
`;

export const SelectUsersErrorLabel = styled.div`
  color: red;
  font-size: 12px;
  margin-top: 4px;
`;

export const InnerSection = styled.div`
  padding: 16px;
  border: 1px solid rgba(0, 0, 0, 0.25);
  border-radius: 3px;
`;

export const Divisor = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  height: 100%;
  font-weight: 300;

  span {
    display: flex;
    align-items: center;
    &:before,
    &:after {
      content: '';
      width: 14px;
      height: 1px;
      background-color: rgba(0, 0, 0, 0.15);
    }

    &:before {
      margin-right: 8px;
    }

    &:after {
      margin-left: 8px;
    }
  }
`;

export const ChargeboxCircle = styled.div`
  background-color: ${COLORS.transparentDark};
  border-radius: 50%;
  width: 35px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
`;

export const ChargeboxText = styled.div`
  font-weight: 300;
  font-size: 16px;

  &::after {
    content: '';
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: ${COLORS.transparentIcon};
    margin: 0 24px;
  }
`;

export const Link = styled.div`
  color: ${({ theme }) => theme.primary};
`;
